import authenticateInterceptor from "@/authentication/authenticateInterceptor"
import handleAuthErrorInterceptor from "@/authentication/handleAuthErrorInterceptor"
import setOriginInterceptor from "@/authentication/native/setOriginInterceptor"
import nativeHelper from "@/lib/nativeHelper"
import axios, { AxiosError, AxiosRequestConfig } from "axios"

export const AXIOS_INSTANCE = axios.create({
  baseURL: import.meta.env.VITE_API_GATEWAY_2_URL,
})

if (nativeHelper.isNative()) {
  AXIOS_INSTANCE.interceptors.request.use(setOriginInterceptor)
}
AXIOS_INSTANCE.interceptors.request.use(authenticateInterceptor)
AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  handleAuthErrorInterceptor,
)

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = axios.CancelToken.source()
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data)

  // @ts-ignore
  promise.cancel = () => {
    source.cancel("Query was cancelled")
  }

  return promise
}
export type ErrorType<Error> = AxiosError<Error>
